// extracted by mini-css-extract-plugin
module.exports = {"component":"composable-content_component__KbYyP"};